import React from 'react';
import PageHeader from "../../components/PageHeader";


const ComingSoon = () => {
    return (
        <PageHeader
        bgImg={require("../../assets/img/constrution.jpg")}
        title=""
        content=""
      />
    //   <div className="coming-soon-container">
    //     <h2 className="coming-soon-title">Coming Soon!</h2>
    //     <p className="coming-soon-text">We're working on something awesome. Stay tuned for updates.</p>
    //     {/* You can add additional information or styling as needed */}
    //   </div>
    );
  };
  
  export default ComingSoon;